import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { ModalContainer } from "../../../../common/components/modal_container";
import { ModalLoading } from "../../../../common/components/modal_loading";
import { useCallback, useEffect, useState } from "react";
import { ObraHeaderInfo } from "../../domain/models/obra_header_info";
import { IrParaAction } from "./ir_para_action";

import CommonConstants from "../../../../common/constants";
import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { RestricoesPainelObra } from "../../domain/models/restricoes_painel_obra";

/**
 * IrParaModal
 */

type Props = {
  open: boolean;
  selectedObra: ObraHeaderInfo | null;
  onClose: () => void;
  onExecuteAction: (idAction: number, idObra: number | null, openNewTab: boolean) => void;
};


export const IrParaModal = ({ open, selectedObra, onClose, onExecuteAction }: Props) => {

  const {
    obras: {
      getRestricoesPainelObraUseCase,
    }
  } = useDependencyInjection();

  const [restricoesPainelObra, setRestricoesPainelObra] = useState<RestricoesPainelObra | null>(null);

  useEffect(() => {
    const fetchRestricoesPainelObra = async () => {
      const restricoes = await getRestricoesPainelObraUseCase.execute();
      setRestricoesPainelObra(restricoes);
    };

    if (open) {
      fetchRestricoesPainelObra();
    }
  }, [open, getRestricoesPainelObraUseCase]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "40rem",
          },
        },
      }}
    >
      <DialogTitle>Ir para</DialogTitle>

      <DialogContent>
        <ModalLoading loading={false}>
          <ModalContainer>
            <div className="grid grid-cols-4 gap-4 my-4">
              {
                restricoesPainelObra?.possuiInformacoesGerais &&
                <IrParaAction
                  id={CommonConstants.obrasActions.informacoesGerais}
                  icon="AppRegistrationOutlined"
                  label="Informações Gerais"
                  onExecuteAction={(id, openNewTab) =>
                    onExecuteAction(id, selectedObra && selectedObra.idObra ? selectedObra.idObra : null, openNewTab)
                  }
                />
              }
              {
                restricoesPainelObra?.possuiCheckListArea &&
                <IrParaAction
                  id={CommonConstants.obrasActions.checklistArea}
                  icon="AccountTree"
                  label="Checklist de Área"
                  onExecuteAction={(id, openNewTab) =>
                    onExecuteAction(id, selectedObra && selectedObra.idObra ? selectedObra.idObra : null, openNewTab)
                  }
                />
              }
              {
                restricoesPainelObra?.possuiMapaConcretagem &&
                <IrParaAction
                  id={CommonConstants.obrasActions.mapaConcretagem}
                  icon="MapOutlined"
                  label="Mapa de concretagem"
                  onExecuteAction={(id, openNewTab) =>
                    onExecuteAction(id, selectedObra && selectedObra.idObra ? selectedObra.idObra : null, openNewTab)
                  }
                />
              }
              {
                restricoesPainelObra?.possuiEquipamentoMedicao &&
                <IrParaAction
                  id={CommonConstants.obrasActions.equipamentoMedicao}
                  icon="StraightenOutlined"
                  label="Equipamento de medição"
                  onExecuteAction={(id, openNewTab) =>
                    onExecuteAction(id, selectedObra && selectedObra.idObra ? selectedObra.idObra : null, openNewTab)
                  }
                />
              }
              {
                restricoesPainelObra?.possuiEquipamentoCritico &&
                <IrParaAction
                  id={CommonConstants.obrasActions.equipamentoCritico}
                  icon="BiotechOutlined"
                  label="Equipamento crítico"
                  onExecuteAction={(id, openNewTab) =>
                    onExecuteAction(id, selectedObra && selectedObra.idObra ? selectedObra.idObra : null, openNewTab)
                  }
                />
              }
              {
                restricoesPainelObra?.possuiTreinamentos &&
                <IrParaAction
                  id={CommonConstants.obrasActions.treinamentos}
                  icon="EngineeringOutlined"
                  label="Treinamentos"
                  onExecuteAction={(id, openNewTab) =>
                    onExecuteAction(id, selectedObra && selectedObra.idObra ? selectedObra.idObra : null, openNewTab)
                  }
                />
              }
              {
                restricoesPainelObra?.possuiGestaoResiduos &&
                <IrParaAction
                  id={CommonConstants.obrasActions.gestaoResiduos}
                  icon="HubOutlined"
                  label="Gestão de resíduos (PGRCC)"
                  onExecuteAction={(id, openNewTab) =>
                    onExecuteAction(id, selectedObra && selectedObra.idObra ? selectedObra.idObra : null, openNewTab)
                  }
                />
              }
              {
                restricoesPainelObra?.possuiAlvenariaEstrutural &&
                <IrParaAction
                  id={CommonConstants.obrasActions.alvenariaEstrutural}
                  icon="HouseOutlined"
                  label="Alvenaria estrutural"
                  onExecuteAction={(id, openNewTab) =>
                    onExecuteAction(id, selectedObra && selectedObra.idObra ? selectedObra.idObra : null, openNewTab)
                  }
                />
              }
              {
                restricoesPainelObra?.possuiRelacaoDeMateriaisControlados &&
                <IrParaAction
                  id={CommonConstants.obrasActions.relacaoMateriaisControlados}
                  icon="OilBarrelOutlined"
                  label="Relação de materiais controlados"
                  onExecuteAction={(id, openNewTab) =>
                    onExecuteAction(id, selectedObra && selectedObra.idObra ? selectedObra.idObra : null, openNewTab)
                  }
                />
              }
              {
                restricoesPainelObra?.possuiRelacaoDeServicosControlados &&
                <IrParaAction
                  id={CommonConstants.obrasActions.relacaoServicosControlados}
                  icon="OnDeviceTrainingOutlined"
                  label="Relação de serviços controlados"
                  onExecuteAction={(id, openNewTab) =>
                    onExecuteAction(id, selectedObra && selectedObra.idObra ? selectedObra.idObra : null, openNewTab)
                  }
                />
              }
              {
                restricoesPainelObra?.possuiSustentabilidade &&
                <IrParaAction
                  id={CommonConstants.obrasActions.sustentabilidade}
                  icon="Compost"
                  label="Sustentabilidade"
                  onExecuteAction={(id, openNewTab) =>
                    onExecuteAction(id, selectedObra && selectedObra.idObra ? selectedObra.idObra : null, openNewTab)
                  }
                />
              }
              {
                restricoesPainelObra?.possuiInformacoesGerais &&
                <IrParaAction
                  id={CommonConstants.obrasActions.documentos}
                  icon="EditDocument"
                  label="Documentos"
                  onExecuteAction={(id, openNewTab) =>
                    onExecuteAction(id, selectedObra && selectedObra.idObra ? selectedObra.idObra : null, openNewTab)
                  }
                />
              }
            </div>
          </ModalContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-between flex px-4 pb-4 gap-4">
          <div></div>

          <div className="flex flex-row">
            <div className="flex flex-row gap-2">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1 className="text-sm text-black dark:text-white" onClick={handleClose}>
                  Cancelar
                </h1>
              </div>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
};
